/**
 * apps/admin 分析层 · 包装 @cs-agent/analytics + 注入 posthog 单例
 *
 * 承接：
 * - T11 §12.5 实现约束 · 集中 schema · 单点入口
 * - main.tsx 已 init posthog（DSN 空跳过）· 这里复用同一实例
 *
 * 用法（路由组件 / 业务交互）：
 *   import { trackEvent } from "@/lib/analytics";
 *   trackEvent({ event: "admin_page_view", properties: { mxx_id: "M01", url, duration_sec: 0 } });
 */
import { type AdminEventInput, track } from "@cs-agent/analytics";
import posthog from "posthog-js";

/** dev 默认 console.debug · prod 关闭（避免污染日志） */
const isDev = import.meta.env.DEV;

export function trackEvent(event: AdminEventInput): void {
	track(event, { posthog, debug: isDev });
}
